module.exports = __webpack_public_path__ + "static/media/home-header.ec492f5f.jpg";